/* Carrusel de resenas (v10/v11).
   Autonomo: no depende de hd.js ni de ninguna libreria.
   Rota solo, se frena cuando el mouse esta encima o cuando algo
   adentro tiene el foco, y se frena si la pestana queda en segundo plano.

   NOTA v11: antes el carrusel NO rotaba si el visitante tenia activado
   "reducir movimiento" en su sistema. Con un publico de 55 a 75 anios eso
   es frecuente y se perdia toda la prueba social salvo la primera ficha.
   Ahora la rotacion corre siempre; lo que se desactiva con esa preferencia
   es el fundido, que se apaga desde el CSS. */
(function () {
  'use strict';

  function armar(caja) {
    if (!caja || caja.dataset.hdListo === '1') return;
    caja.dataset.hdListo = '1';

    var fichas = Array.prototype.slice.call(caja.querySelectorAll('[data-hd-resena]'));
    if (fichas.length === 0) return;

    var prev = caja.querySelector('[data-hd-resena-prev]');
    var next = caja.querySelector('[data-hd-resena-next]');

    if (fichas.length === 1) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    var actual = 0;
    var reloj = null;

    var segundos = parseInt(caja.dataset.intervalo, 10);
    if (isNaN(segundos) || segundos < 2) segundos = 6;
    var espera = segundos * 1000;

    function mostrar(i) {
      actual = (i + fichas.length) % fichas.length;
      fichas.forEach(function (ficha, n) {
        var activa = n === actual;
        ficha.classList.toggle('hd-activo', activa);
        if (activa) {
          ficha.removeAttribute('aria-hidden');
        } else {
          ficha.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function arrancar() {
      if (reloj) return;
      reloj = window.setInterval(function () {
        mostrar(actual + 1);
      }, espera);
    }

    function frenar() {
      if (!reloj) return;
      window.clearInterval(reloj);
      reloj = null;
    }

    function manual(paso) {
      frenar();
      mostrar(actual + paso);
      arrancar();
    }

    if (prev) prev.addEventListener('click', function () { manual(-1); });
    if (next) next.addEventListener('click', function () { manual(1); });

    caja.addEventListener('mouseenter', frenar);
    caja.addEventListener('mouseleave', arrancar);
    caja.addEventListener('focusin', frenar);
    caja.addEventListener('focusout', arrancar);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { frenar(); } else { arrancar(); }
    });

    mostrar(0);
    arrancar();
  }

  function barrer(raiz) {
    var alcance = raiz && raiz.querySelectorAll ? raiz : document;
    Array.prototype.forEach.call(alcance.querySelectorAll('[data-hd-resenas]'), armar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { barrer(document); });
  } else {
    barrer(document);
  }

  /* El editor de temas vuelve a dibujar la seccion sin recargar la pagina. */
  document.addEventListener('shopify:section:load', function (evento) {
    barrer(evento.target || document);
  });
  document.addEventListener('shopify:section:unload', function (evento) {
    var caja = evento.target && evento.target.querySelector
      ? evento.target.querySelector('[data-hd-resenas]')
      : null;
    if (caja) caja.dataset.hdListo = '';
  });
})();